











































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import ExtensionCategoryListModel from '@/models/extension/extensionCategoryListModel'
import ExtensionCategoryQuestionModel from '@/models/extension/extensionCategoryQuestionModel'
import ExtensionCategoryQuestionAnswerModel from '@/models/extension/extensionCategoryQuestionAnswerModel'
import apiService from '../../services/apiService'
import { UrlType } from '@/constants/urlType'

@Component
export default class QuestionList extends Vue {
  @Prop(String) readonly investigationId!: string
  @Prop(Array) readonly categories!: Array<ExtensionCategoryListModel>
  @Prop(Boolean) readonly disabled!: boolean

  private selected: Array<ExtensionCategoryQuestionModel> = []

  @Emit()
  private async answerToggled(
    question: ExtensionCategoryQuestionModel
  ): Promise<void> {
    if (!question.isChecked) {
      this.createAnswer(question)
    } else {
      this.deleteAnswer(question)
    }
  }

  private async createAnswer(
    question: ExtensionCategoryQuestionModel
  ): Promise<void> {
    await apiService.post<ExtensionCategoryQuestionAnswerModel>(
      UrlType.ExtensionCategoryQuestionAnswer,
      new ExtensionCategoryQuestionAnswerModel({
        extensionCategoryQuestionId: question.extensionCategoryQuestionId,
        extensionInvestigationId: this.investigationId
      })
    )
  }

  private async deleteAnswer(
    question: ExtensionCategoryQuestionModel
  ): Promise<void> {
    const confirm = window.confirm(
      'Are you sure you would like to uncheck this question? Any notes saved will be deleted.'
    )

    if (confirm) {
      await apiService.delete(
        UrlType.ExtensionCategoryQuestionAnswer,
        question.answerId
      )
    }
  }

  @Emit()
  private addNote(answerId: string): string {
    return answerId
  }

  @Watch('categories', { immediate: true })
  private onCategoriesChanged() {
    for (const category of this.categories) {
      const checked = category.extensionCategoryQuestions.filter(
        x => x.isChecked
      )
      this.selected.push(...checked)
    }
  }
}
